import { createTheme, ThemeProvider  } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const theme = createTheme({
  palette: {
    secondary: {
      main: '#5C7F67'
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App/>
    </ThemeProvider>
   
  </React.StrictMode>
);

